import React from 'react'
import moment from 'moment'
import { buildings } from '../../core/controllers/Buildings'
import { sensorAnalytics } from '../../core/controllers/SensorAnalytics'
export default class BuildingSensorHistory extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            doors_opened: null,
            doors_closed: null,
            temperature: null,
            smoke_alarms_clear: null,
            smoke_alarms_triggered: null,
            water_detected: null,
            startDate: moment(moment().subtract(7, "days").format("YYYY-MM-DD")),
            endDate: moment(moment().format("YYYY-MM-DD")),
        }
    }

    componentDidMount() {
        var self = this;
        jQuery('.daterange').daterangepicker({
            opens: 'left',
            "startDate": self.state.startDate,
            "endDate": self.state.endDate,
            "showDropdowns": true,
            "drops": "down",
            "minYear": Number(moment().format("YYYY")) - 3,
            "maxYear": Number(moment().format("YYYY")),
        },  function(start, end) {
            self.onDateRangePick(start, end)
        });

        sensorAnalytics.getTrends(this.state.startDate.format("YYYY-MM-DD"), this.state.endDate.format("YYYY-MM-DD"), this.props.buildingId, function(response) {
            self.processData(response);
        });
    }

    processData(response) {
        const data = response.data;
        if (Object.keys(data).length > 0) {
            var chartData = new Array();

            const keys = Object.keys(data);
            keys.forEach(key => {
                chartData[key] = new Array();
                const sensorData = data[key];
                const months = Object.keys(sensorData).reverse()
                months.forEach(month => {
                    const monthData = sensorData[month];
                    // we're dealing with month by month data
                    if (Array.isArray(monthData)) {
                        chartData[key][month] = new Array();
                        var monthsAvg   = 0;
                        var doorsOpen   = 0;
                        var doorsClosed = 0;
                        var smokeClear  = 0;
                        var smokeFound  = 0;
                        var floodDry    = 0;
                        var floodWet    = 0;
                        monthData.forEach(single => {
                            if (!isNaN(single.value)) {
                                monthsAvg = parseFloat(single.value) + monthsAvg;
                            } else {
                                if (key == 'door') {
                                    if (single.value == 'open') {
                                        doorsOpen++;
                                    } else {
                                        doorsClosed++;
                                    }
                                } else if (key == 'smoke') {
                                    if (single.value == 'clear') {
                                        smokeClear++;
                                    } else {
                                        smokeFound++;
                                    }
                                } else if (key == 'flood') {
                                    if (single.value == 'wet') {
                                        floodWet++;
                                    } else {
                                        floodDry++;
                                    }
                                }
                            }
                        });
                        if (key == 'temp') {
                            if (!isNaN(monthsAvg)) {
                                monthsAvg = monthsAvg / monthData.length;
                                chartData[key][month] = monthsAvg;
                            } else {
                                chartData[key][month] = 0;
                            }
                        } else if (key == 'door') {
                            chartData[key][month]     = doorsOpen;
                        } else if (key == 'smoke') {
                            chartData[key][month]     = smokeFound;
                        } else if (key == 'flood') {
                            chartData[key][month]     = floodWet;
                        }
                    } else {
                        // we're dealing with day by day data
                        const days = Object.keys(monthData).reverse();
                        days.forEach(day => {
                            chartData[key][day] = new Array();
                            const daysData  = monthData[day];
                            var daysAvg     = 0;
                            var doorsOpen   = 0;
                            var doorsClosed = 0;
                            var smokeClear  = 0;
                            var smokeFound  = 0;
                            var floodDry    = 0;
                            var floodWet    = 0;
                            daysData.forEach(dayData => {
                                if (!isNaN(dayData.value)) {
                                    daysAvg = parseFloat(dayData.value) + daysAvg;
                                } else {
                                    if (key == 'door') {
                                        if (dayData.value == 'open') {
                                            doorsOpen++;
                                        } else {
                                            doorsClosed++;
                                        }
                                    } else if (key == 'smoke') {
                                        if (dayData.value == 'clear') {
                                            smokeClear++;
                                        } else {
                                            smokeFound++;
                                        }
                                    } else if (key == 'flood') {
                                        if (dayData.value == 'wet') {
                                            floodWet++;
                                        } else {
                                            floodDry++;
                                        }
                                    }
                                }
                            });

                            if (key == 'temp') {
                                if (!isNaN(daysAvg)) {
                                    daysAvg = daysAvg / daysData.length;
                                    chartData[key][day] = daysAvg;
                                } else {
                                    chartData[key][day] = 0;
                                }
                            } else if (key == 'door') {
                                chartData[key][day]     = doorsOpen;
                            } else if (key == 'smoke') {
                                chartData[key][day]     = smokeFound;
                            } else if (key == 'flood') {
                                chartData[key][day]     = floodWet;
                            }
                        });
                    }
                });
            });

            if (chartData.hasOwnProperty('temp')) {
                this.createTemperatureChart(chartData.temp);
            }
            if (chartData.hasOwnProperty('door')) {
                this.createDoorsOpenedChart(chartData.door);
            }
            if (chartData.hasOwnProperty('flood')) {
                this.createFloodChart(chartData.flood);
            }
            if (chartData.hasOwnProperty('smoke')) {
                this.createSmokeChart(chartData.smoke);
            }
        }
    }

    createTemperatureChart(chartData) {
        let draw = Chart.controllers.line.prototype.draw;
        Chart.controllers.line.prototype.draw = function() {
            draw.apply(this, arguments);
            let ctx = this.chart.chart.ctx;
            let _stroke = ctx.stroke;
            ctx.stroke = function() {
                ctx.save();
                ctx.shadowColor = '#707070';
                ctx.shadowBlur = 12;
                ctx.shadowOffsetX = 0;
                ctx.shadowOffsetY = 8;
                _stroke.apply(this, arguments);
                ctx.restore();
            }
        };

        const labels = Object.keys(chartData)
        const values = Object.values(chartData)
        const canvas = document.getElementById('temperature');
        const ctx    = canvas.getContext('2d');

        const gradient = ctx.createLinearGradient(0, 0, 0, 250);
        gradient.addColorStop(0, 'rgba(21, 156, 160, 0.5)');
        gradient.addColorStop(0.5, 'rgba(21, 156, 160, 0.25)');
        gradient.addColorStop(1, 'rgba(21, 156, 160, 0)');
        var chart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: labels,
                datasets: [{
                    label: 'Temperatures',
                    data: values,
                    backgroundColor: gradient,
                    pointBackgroundColor: '#159CA0',
                    borderColor: '#159CA0',
                    borderWidth: 3
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                animation: {
                    easing: 'easeInOutQuad',
                    duration: 520
                },
                scales: {
                    xAxes: [{
                        gridLines: {
                            color: 'rgba(200, 200, 200, 0.05)',
                            lineWidth: 1
                        }
                    }],
                    yAxes: [{
                        gridLines: {
                            color: 'rgba(200, 200, 200, 0.08)',
                            lineWidth: 1
                        },
                        ticks: {
                            beginAtZero: true,
                            // callback: function(value,index,array) { return (value < 1000000) ? value/1000 + 'K' : value/1000000 + 'M'; }
                        }
                    }]
                },
                elements: {
                    line: {
                        tension: 0.4
                    }
                },
                legend: {
                    display: false
                },
                point: {
                    backgroundColor: 'white'
                },
                tooltips: {
                    titleFontFamily: 'Open Sans',
                    backgroundColor: 'rgba(0,0,0,0.3)',
                    titleFontColor: '#070F29',
                    caretSize: 5,
                    cornerRadius: 2,
                    xPadding: 10,
                    yPadding: 10
                }
            }
        });
    }

    createDoorsOpenedChart(chartData) {
        const labels = Object.keys(chartData)
        const values = Object.values(chartData)
        const canvas = document.getElementById('doors');
        const ctx    = canvas.getContext('2d');

        const gradient = ctx.createLinearGradient(0, 0, 0, 250);
        gradient.addColorStop(0, 'rgba(242, 100, 0, 0.5)');
        gradient.addColorStop(0.5, 'rgba(242, 100, 0, 0.25)');
        gradient.addColorStop(1, 'rgba(242, 100, 0, 0)');

        var chart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: labels,
                datasets: [{
                    label: 'Doors Opened',
                    data: values,
                    backgroundColor: gradient,
                    pointBackgroundColor: '#F26400',
                    borderColor: '#F26400',
                    borderWidth: 3
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                animation: {
                    easing: 'easeInOutQuad',
                    duration: 520
                },
                scales: {
                    xAxes: [{
                        gridLines: {
                            color: 'rgba(200, 200, 200, 0.05)',
                            lineWidth: 1
                        }
                    }],
                    yAxes: [{
                        gridLines: {
                            color: 'rgba(200, 200, 200, 0.08)',
                            lineWidth: 1
                        },
                        ticks: {
                            beginAtZero: true,
                            // callback: function(value,index,array) { return (value < 1000000) ? value/1000 + 'K' : value/1000000 + 'M'; }
                        }
                    }]
                },
                elements: {
                    line: {
                        tension: 0.4
                    }
                },
                legend: {
                    display: false
                },
                point: {
                    backgroundColor: 'white'
                },
                tooltips: {
                    titleFontFamily: 'Open Sans',
                    backgroundColor: 'rgba(0,0,0,0.3)',
                    titleFontColor: '#070F29',
                    caretSize: 5,
                    cornerRadius: 2,
                    xPadding: 10,
                    yPadding: 10
                }
            }
        });
    }

    createFloodChart(chartData) {
        const labels = Object.keys(chartData)
        const values = Object.values(chartData)
        const canvas = document.getElementById('flood');
        const ctx    = canvas.getContext('2d');

        const gradient = ctx.createLinearGradient(0, 0, 0, 250);
        gradient.addColorStop(0, 'rgba(58, 155, 242, 0.5)');
        gradient.addColorStop(0.5, 'rgba(58, 155, 242, 0.25)');
        gradient.addColorStop(1, 'rgba(58, 155, 242, 0)');

        var chart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: labels,
                datasets: [{
                    label: 'Water Detected',
                    data: values,
                    backgroundColor: gradient,
                    pointBackgroundColor: '#0078FF',
                    borderColor: '#0078FF',
                    borderWidth: 3
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                animation: {
                    easing: 'easeInOutQuad',
                    duration: 520
                },
                scales: {
                    xAxes: [{
                        gridLines: {
                            color: 'rgba(200, 200, 200, 0.05)',
                            lineWidth: 1
                        }
                    }],
                    yAxes: [{
                        gridLines: {
                            color: 'rgba(200, 200, 200, 0.08)',
                            lineWidth: 1
                        },
                        ticks: {
                            beginAtZero: true,
                            // callback: function(value,index,array) { return (value < 1000000) ? value/1000 + 'K' : value/1000000 + 'M'; }
                        }
                    }]
                },
                elements: {
                    line: {
                        tension: 0.4
                    }
                },
                legend: {
                    display: false
                },
                point: {
                    backgroundColor: 'white'
                },
                tooltips: {
                    titleFontFamily: 'Open Sans',
                    backgroundColor: 'rgba(0,0,0,0.3)',
                    titleFontColor: '#070F29',
                    caretSize: 5,
                    cornerRadius: 2,
                    xPadding: 10,
                    yPadding: 10
                }
            }
        });
    }

    createSmokeChart(chartData) {
        const labels = Object.keys(chartData)
        const values = Object.values(chartData)
        const canvas = document.getElementById('smoke');
        const ctx    = canvas.getContext('2d');

        const gradient = ctx.createLinearGradient(0, 0, 0, 250);
        gradient.addColorStop(0, 'rgba(243, 30, 22, 0.5)');
        gradient.addColorStop(0.5, 'rgba(243, 30, 22, 0.25)');
        gradient.addColorStop(1, 'rgba(243, 30, 22, 0)');

        var chart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: labels,
                datasets: [{
                    label: 'Smoke Detected',
                    data: values,
                    backgroundColor: gradient,
                    pointBackgroundColor: '#F31E16',
                    borderColor: '#F31E16',
                    borderWidth: 3
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                animation: {
                    easing: 'easeInOutQuad',
                    duration: 520
                },
                scales: {
                    xAxes: [{
                        gridLines: {
                            color: 'rgba(200, 200, 200, 0.05)',
                            lineWidth: 1
                        }
                    }],
                    yAxes: [{
                        gridLines: {
                            color: 'rgba(200, 200, 200, 0.08)',
                            lineWidth: 1
                        },
                        ticks: {
                            beginAtZero: true,
                            // callback: function(value,index,array) { return (value < 1000000) ? value/1000 + 'K' : value/1000000 + 'M'; }
                        }
                    }]
                },
                elements: {
                    line: {
                        tension: 0.4
                    }
                },
                legend: {
                    display: false
                },
                point: {
                    backgroundColor: 'white'
                },
                tooltips: {
                    titleFontFamily: 'Open Sans',
                    backgroundColor: 'rgba(0,0,0,0.3)',
                    titleFontColor: '#070F29',
                    caretSize: 5,
                    cornerRadius: 2,
                    xPadding: 10,
                    yPadding: 10
                }
            }
        });
    }

    onDateRangePick(start, end) {
        var self = this;
        this.setState({
            startDate: start,
            endDate: end,
        });
        jQuery('#daterange').data('daterangepicker').setStartDate(moment(start));
        jQuery('#daterange').data('daterangepicker').setEndDate(moment(end));

        sensorAnalytics.getTrends(start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD"), this.props.buildingId, function(response) {
            self.processData(response);
        });
    }

    render(){
        const startDate = this.state.startDate;
        const endDate = this.state.endDate;
        return (
            <div>
                <div class="row">
                    <div class="col-md-3 col-md-offset-4">
                        <div class="form-group" style={{textAlign: "center"}}>
                            <label>Filter sensor data based off of range:</label>
                            <input style={{textAlign: "center"}} type="text" class="form-control daterange" id="daterange" value={startDate + " - " + endDate} onChange={this.onDateRangePick.bind(this)}/>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="card">
                            <div class="header">
                                <h4 class="card-icon-title"><span class="card-box-icon green-card-icon-circle"><i class="icon-temperature-fancy"></i></span> Temperature</h4>
                                <p class="category">Showing temperature trends from {startDate.format("M-D-Y")} to {endDate.format("M-D-Y")}</p>
                            </div>
                            <div class="content">
                                <div class="row">
                                    <hr></hr>
                                    <div class="col-md-12">
                                        <canvas id="temperature"></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="card">
                            <div class="header">
                                <h4 class="card-icon-title"><span class="card-box-icon orange-card-icon-circle"><i class="icon-door-open-outline"></i></span> Doors Opened</h4>
                                <p class="category">Showing doors opened from {startDate.format("M-D-Y")} to {endDate.format("M-D-Y")}</p>
                            </div>
                            <div class="content">
                                <div class="row">
                                    <hr></hr>
                                    <div class="col-md-12">
                                        <canvas id="doors"></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="card">
                            <div class="header">
                                <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-water-drop-fancy"></i></span> Water Detected</h4>
                                <p class="category">Showing water detections from {startDate.format("M-D-Y")} to {endDate.format("M-D-Y")}</p>
                            </div>
                            <div class="content">
                                <div class="row">
                                    <hr></hr>
                                    <div class="col-md-12">
                                        <canvas id="flood"></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="card">
                            <div class="header">
                                <h4 class="card-icon-title"><span class="card-box-icon red-card-icon-circle"><i class="icon-smoke-alarm"></i></span> Smoke Detected</h4>
                                <p class="category">Showing smoke detected from {startDate.format("M-D-Y")} to {endDate.format("M-D-Y")}</p>
                            </div>
                            <div class="content">
                                <div class="row">
                                    <hr></hr>
                                    <div class="col-md-12">
                                        <canvas id="smoke"></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Building/BuildingSensorHistory.jsx